import { useEffect, useMemo, useState } from 'react';
import './App.css';

import Man1 from './Man1.svg';
import Man9 from './Man9.svg';
import Sou1 from './Sou1.svg';
import Sou9 from './Sou9.svg';
import Pin1 from './Pin1.svg';
import Pin9 from './Pin9.svg';
import Ton from './Ton.svg';
import Nan from './Nan.svg';
import Shaa from './Shaa.svg';
import Pei from './Pei.svg';
import Chun from './Chun.svg';
import Haku from './Haku.svg';
import Hatsu from './Hatsu.svg';

function App() {
  const orphanHand = useMemo(() =>[Man1, Man9, Sou1, Sou9, Pin1, Pin9, Ton, Nan, Shaa, Pei, Chun, Haku, Hatsu], []);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(i =>
        i + 1 >= orphanHand.length ? 0 : i + 1
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [currentIndex, orphanHand]);

  return (
    <div className="App">
      <h1>You will always be my <span style={{
        color: "rgb(216, 135, 148)"
      }}>perfect pair!</span></h1>
      <h1>Happy <span style={{
        color: "rgb(216, 135, 148)"
      }}>RA</span>lentine's Day!</h1>
      <div className='flex' style={{
        position: 'relative',
        marginTop: '5em',
      }}>
        <img className="tile rotate" src={orphanHand[currentIndex]}/>
        {
          orphanHand.map((tile) => {
            return <img className="tile" src={tile}/>
          })
        }
      </div>
    </div>
  );
}

export default App;
